import React from 'react';
import AgentTrustCenterPage from '../AgentTrustCenterPageV2';

/* G301 — Deep-link wrapper into the unified Trust Center.
 *
 * Pre-selects the "ExteLets" scope. See NativeTrustCenterPage for the
 * full design rationale — the V2 Trust Center is one page covering
 * both Lets and ExteLets, and the in-page segmented control lets the
 * operator toggle between them. This wrapper only sets the initial
 * scope so historical /trust/external bookmarks still land where
 * expected.
 */
export default function ExternalTrustCenterPage() {
  return <AgentTrustCenterPage agentScope="external" />;
}
